import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Lock, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function Footer() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/site-content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="mt-24 bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="bg-white rounded-2xl p-2.5 shadow-lg">
              <img src="/assets/shine-logo.png" alt="Shine Fabric" className="h-10 w-auto"/>
            </div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-400">Excellence in every stitch</div>
          </div>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-400">
            High-quality apparels designed, manufactured & delivered on time. Trendy clothing for boys & girls,
            crafted with love in Tirupur, India.
          </p>
        </div>
        <div className="md:col-span-2">
          <h4 className="font-display text-lg text-white mb-4">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop?category=girls" className="hover:text-pink-400 transition-colors">Girls Wear</Link></li>
            <li><Link to="/shop?category=boys" className="hover:text-sky-400 transition-colors">Boys Wear</Link></li>
            <li><Link to="/shop" className="hover:text-yellow-400 transition-colors">All Collections</Link></li>
            <li><Link to="/track-order" className="hover:text-white transition-colors">Track order</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <h4 className="font-display text-lg text-white mb-4">Help</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact us</Link></li>
            <li><Link to="/size-guide" className="hover:text-white transition-colors">Size guide</Link></li>
            <li><Link to="/shipping-policy" className="hover:text-white transition-colors">Shipping</Link></li>
            <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-display text-lg text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-sky-400"/>{content?.contact_phone || "+91 96007 74355"}</li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-pink-400"/>{content?.contact_email || "shinefabric@gmail.com"}</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-yellow-400"/>{content?.contact_address || "Tirupur, Tamil Nadu, India"}</li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a href={content?.instagram_url || "#"} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"><Instagram className="w-4 h-4"/></a>
            <a href={content?.facebook_url || "#"} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"><Facebook className="w-4 h-4"/></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-testid="footer-secure-badges">
          <div className="flex items-center gap-1.5 text-slate-400" data-testid="footer-badge-ssl">
            <Lock className="w-5 h-5 text-slate-500" strokeWidth={2} />
            <span className="text-xs font-semibold">SSL Secure</span>
          </div>
          <div className="flex items-center gap-2 text-slate-400" data-testid="footer-badge-razorpay">
            <span className="bg-white rounded px-1.5 py-1 flex items-center">
              <img src="/images/razorpay-logo.svg" alt="Razorpay" className="h-4 w-auto" />
            </span>
            <span className="text-xs font-semibold">Payments by Razorpay</span>
          </div>
          <div className="flex items-center gap-1.5 text-slate-400" data-testid="footer-badge-safe-checkout">
            <ShieldCheck className="w-5 h-5 text-slate-500" strokeWidth={2} />
            <span className="text-xs font-semibold">100% Safe Checkout</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs flex flex-col sm:flex-row justify-between gap-2 text-slate-500">
          <div>© {new Date().getFullYear()} Shine Fabric. All rights reserved.</div>
          <div>Made with care · Tirupur, India</div>
        </div>
      </div>
    </footer>
  );
}
